import { render } from "./NamedField.vue?vue&type=template&id=2b98872a"
import script from "./NamedField.vue?vue&type=script&lang=js"
export * from "./NamedField.vue?vue&type=script&lang=js"

import "./NamedField.vue?vue&type=style&index=0&id=2b98872a&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__